// A phone photo made small for the pallet check: the longest side to 1600 px, JPEG ~0.8 (mobile/ui
// shrinkPhoto, the receiving / part photo shrinker), so a problem photo stays well under the API's 4 MB.

import { shrinkPhoto } from '../../mobile/ui/shrinkPhoto';

export const CHECK_PHOTO_MAX_SIDE = 1600;
export const CHECK_PHOTO_QUALITY = 0.8;

/** The photo as a smaller JPEG File (the original when it can't be shrunk here). */
export function smallPhoto(file) {
  return shrinkPhoto(file, { maxSide: CHECK_PHOTO_MAX_SIDE, quality: CHECK_PHOTO_QUALITY, keepUnder: 0 });
}

/** A File as a data: URL. */
export function fileAsDataUrl(file) {
  return new Promise((resolve, reject) => {
    const r = new FileReader();
    r.onload = () => resolve(String(r.result || ''));
    r.onerror = () => reject(r.error || new Error('Could not read the photo'));
    r.readAsDataURL(file);
  });
}

/** Shrunk and read: {dataUrl, file}. */
export async function photoForCheck(file) {
  const small = await smallPhoto(file);
  const dataUrl = await fileAsDataUrl(small);
  return { dataUrl, file: small };
}
